import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgMailAlt = function SvgMailAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M19.93 2.531H4.023A3.981 3.981 0 00.04 6.516v10.968a3.981 3.981 0 003.984 3.985h15.954a3.981 3.981 0 003.984-3.985V6.516c0-2.204-1.828-3.985-4.031-3.985zM19.555 4.5l-5.797 6.797a2.462 2.462 0 01-3.516 0L4.445 4.5h15.11zm2.39 12.984c0 1.078-.89 2.016-2.015 2.016H4.023c-1.078 0-2.015-.89-2.015-2.016V6.516c0-.422.14-.844.375-1.172l6.406 7.406a4.43 4.43 0 003.188 1.313 4.508 4.508 0 003.187-1.313l6.406-7.406c.235.328.375.75.375 1.172v10.968z"
  }));
};

export default SvgMailAlt;